import React, { useState } from 'react'
import Subscription from './Subscription'
import Usage from './Usage'

const Index = () => {
    const [toggle,setToggle] = useState('subscription');

  return (
    <div className='tm-main'>
        <div className='overview-head'>
            <div className='overview-head-left'>
            <div className="class-toggle-con" style={{ width: "fit-content" }}>
        <div
          onClick={() => setToggle("subscription")}
          className="class-toggle pe-cursor"
          style={{
            color: toggle == "subscription" && "#030712",
            backgroundColor: toggle == "subscription" && "#FFFFFF",
          }}
        >
          Subscriptions
        </div>
        <div
          onClick={() => setToggle("usage")}
          className="class-toggle pe-cursor"
          style={{
            color: toggle == "usage" && "#030712",
            backgroundColor: toggle == "usage" && "#FFFFFF",
          }}
        >
          {" "}
          Usage{" "}
        </div>
      </div>


            </div>
        </div>
        {toggle == "subscription" && <Subscription />}
        {toggle == "usage" && <Usage />}

    </div>
  )
}

export default Index